import { mount } from 'svelte';
import './styles/tokens.css';
import './styles/global.css';
import App from './App.svelte';
import { shouldEnableTelemetry, readTelemetryOverride } from './lib/logic/telemetry-gate.js';

const app = mount(App, {
  target: document.getElementById('app'),
});

// Browser telemetry, on production hosts only. The import is dynamic so the
// Analytics and Performance SDKs land in their own chunk and never load on
// localhost, in preview channels, or under the Playwright performance harness
// (which serves this same production build). Deferred to idle so it cannot
// compete with the first binder render for main-thread time.
if (
  shouldEnableTelemetry({
    hostname: window.location.hostname,
    webdriver: navigator.webdriver === true,
    override: readTelemetryOverride(),
  })
) {
  const whenIdle = window.requestIdleCallback ?? ((fn) => setTimeout(fn, 1500));
  whenIdle(() => {
    // The chunk itself can fail to load (stale hash after a deploy, offline,
    // blocking extension). install() is internally safe; the import is not.
    import('./lib/services/telemetry.js')
      .then((m) => m.install())
      .catch((error) => console.warn('[Telemetry] Chunk failed to load:', error));
  });
}

export default app;
